export const globalComponentsAccessToken = 'dpk-7L7rGYzkKk-jZwtIDnyhui6DgLq6VTapJNI7W44';

export const globalComponentsSpaceId = 'kp51zybwznx4';

export const globalComponentsEnvName = 'master';

export const globalComponentsClientName = 'global';
